export interface DramaEpisode {
  id: string;
  title: string;
  episodeNumber: number;
  duration: string;
}

export interface Drama {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  totalEpisodes: number;
  updateStatus: string;
  posterImage: string;
  coverImage: string;
  featured: boolean;
  latest: boolean;
  episodes: DramaEpisode[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国产剧', slug: 'chinese' },
  { name: '韩剧', slug: 'korean' },
  { name: '美剧', slug: 'american' },
  { name: '日剧', slug: 'japanese' },
];

export const dramas: Drama[] = [
  {
    id: 'changan-twelve-hours',
    title: '长安十二时辰',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2019,
    rating: 8.2,
    description: '唐朝天宝三年，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。',
    longDescription: '唐朝天宝三年，上元节前夕，长安城热闹非凡。但在这繁华盛世的背后，一场足以摧毁整个长安城的惊天阴谋正在酝酿。死囚张小敬临危受命，与靖安司司丞李必携手，必须在短短十二个时辰内找出幕后黑手，阻止这场灾难。随着调查的深入，一个又一个惊人的秘密浮出水面，各方势力轮番登场，长安城暗流涌动。这是一场与时间赛跑的生死较量，更是一幅展现大唐盛世的壮阔画卷。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 48,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%2C%20Tang%20Dynasty%20warrior%20holding%20sword%20in%20ancient%20city%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20warm%20golden%20tones%2C%20red%20and%20gold%20color%20palette%2C%20movie%20poster%20style%2C%20clean%20composition%2C%20professional%20photography&width=600&height=800&seq=drama-poster-001&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20with%20lanterns%20and%20crowded%20streets%2C%20cinematic%20wide%20shot%2C%20warm%20golden%20evening%20light%2C%20epic%20scale%2C%20atmospheric%20mist%2C%20film%20grain%20texture%2C%20professional%20cinematography&width=1600&height=700&seq=drama-cover-001&orientation=landscape',
    featured: true,
    latest: false,
    episodes: Array.from({ length: 48 }, (_, i) => ({
      id: `changan-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
  },
  {
    id: 'the-long-season',
    title: '漫长的季节',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 9.4,
    description: '跨越二十年的悬疑故事，以东北小城为背景，讲述出租车司机王响、妹夫龚彪与退休警官马德胜共同追查一桩旧案的故事。',
    longDescription: '故事横跨二十年，以东北小城桦林为背景。出租车司机王响原本有个幸福的家庭，但一起碎尸案打破了平静。二十年后，王响的妹夫龚彪和退休警官马德胜因为一个偶然的机会，重新牵出了这桩尘封已久的旧案。三个老男人组成了一支"老年侦探队"，在追查真相的过程中，那些隐藏了二十年的秘密被逐一揭开。这不仅是一部悬疑剧，更是一曲关于时代变迁、人性复杂与命运无常的挽歌。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 12,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20drama%20poster%2C%20three%20middle-aged%20men%20standing%20in%20northeast%20China%20snowy%20landscape%2C%20mysterious%20atmosphere%2C%20dark%20tone%2C%20warm%20brown%20and%20amber%20colors%2C%20film%20noir%20style%2C%20professional%20drama%20poster&width=600&height=800&seq=drama-poster-002&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Northeast%20China%20small%20town%20in%20winter%20with%20snow%20covered%20streets%20and%20old%20buildings%2C%20nostalgic%20atmosphere%2C%20soft%20diffused%20light%2C%20cinematic%20composition%2C%20moody%20tone&width=1600&height=700&seq=drama-cover-002&orientation=landscape',
    featured: true,
    latest: false,
    episodes: Array.from({ length: 12 }, (_, i) => ({
      id: `longseason-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '60分钟',
    })),
  },
  {
    id: 'story-of-yanxi-palace',
    title: '延禧攻略',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2018,
    rating: 7.8,
    description: '乾隆年间，少女魏璎珞为查明姐姐死亡真相，进入紫禁城成为宫女，凭借才智与勇气在深宫中一步步走向权力巅峰。',
    longDescription: '乾隆六年，少女魏璎珞为寻求姐姐死亡真相，进入紫禁城成为宫女。在这座危机四伏的深宫中，她凭借过人的智慧和坚韧的意志，从一个小小的绣坊宫女，一步步成为乾隆皇帝最宠爱的令贵妃。她既要应对来自皇后、高贵妃等后宫势力的明枪暗箭，又要在这复杂的权力游戏中保持初心。这是一部关于女性成长、智慧与勇气的宫廷传奇。',
    director: '惠楷栋',
    actors: ['吴谨言', '秦岚', '聂远', '佘诗曼'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 70,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%2C%20elegant%20woman%20in%20Qing%20Dynasty%20imperial%20costume%20with%20elaborate%20headdress%2C%20red%20and%20gold%20palace%20background%2C%20luxurious%20texture%2C%20royal%20elegance%2C%20dramatic%20portrait%20photography&width=600&height=800&seq=drama-poster-003&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Forbidden%20City%20grand%20hall%20interior%20with%20red%20pillars%20and%20golden%20decorations%2C%20imperial%20Chinese%20palace%2C%20warm%20candlelight%2C%20luxurious%20and%20majestic%2C%20cinematic%20wide%20angle&width=1600&height=700&seq=drama-cover-003&orientation=landscape',
    featured: false,
    latest: false,
    episodes: Array.from({ length: 70 }, (_, i) => ({
      id: `yanxi-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
  },
  {
    id: 'three-body',
    title: '三体',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 8.7,
    description: '根据刘慈欣同名科幻小说改编，讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼与刑警史强联手揭开三体世界秘密的故事。',
    longDescription: '2007年，地球基础科学出现了异常的扰动，多名科学家相继自杀。纳米科学家汪淼被警官史强带到了一个神秘组织——科学边界。为了查明真相，汪淼进入了一款名为"三体"的VR游戏，接触到了一个遥远的外星文明。随着调查的深入，一个关于人类文明生死存亡的巨大秘密逐渐浮出水面。这不仅是科幻，更是一部关于人类文明、科技伦理与生存哲学的思想盛宴。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 30,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20mysterious%20three%20suns%20in%20alien%20sky%2C%20futuristic%20dark%20atmosphere%2C%20cosmic%20horror%20vibe%2C%20deep%20space%20background%2C%20minimalist%20design%2C%20golden%20and%20black%20color%20scheme&width=600&height=800&seq=drama-poster-004&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Massive%20radio%20telescope%20array%20pointing%20at%20starry%20night%20sky%2C%20cosmic%20scale%2C%20deep%20space%20atmosphere%2C%20scientific%20research%20facility%2C%20cinematic%20wide%20shot%2C%20cold%20blue%20and%20gold%20tones&width=1600&height=700&seq=drama-cover-004&orientation=landscape',
    featured: true,
    latest: false,
    episodes: Array.from({ length: 30 }, (_, i) => ({
      id: `threebody-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
  },
  {
    id: 'the-glory',
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2023,
    rating: 8.9,
    description: '年少时遭受校园暴力的文东恩，经过多年精心策划，对当年的施暴者和旁观者展开了一场冷酷而精密的复仇计划。',
    longDescription: '文东恩在高中时期遭受了残酷的校园暴力，施暴者们用卷发棒烫伤了她的全身。退学后，她将复仇作为人生的唯一目标，经过多年精心策划，她成为了施暴者女儿的班主任。一场冷酷而精密的复仇大计就此展开。这部剧不仅仅是一部复仇剧，更是一部深刻揭露校园暴力、阶级固化等社会问题的力作。宋慧乔的精湛演技将文东恩内心的痛苦与决绝展现得淋漓尽致。',
    director: '安吉镐',
    actors: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 16,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%2C%20elegant%20woman%20in%20black%20dress%20with%20cold%20expression%2C%20dark%20minimalist%20background%2C%20contrast%20lighting%2C%20film%20noir%20aesthetic%2C%20professional%20portrait%20photography%2C%20warm%20dark%20tones&width=600&height=800&seq=drama-poster-005&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Snowy%20Seoul%20night%20street%20with%20neon%20signs%2C%20lonely%20figure%20walking%2C%20cold%20atmosphere%2C%20Korean%20urban%20landscape%2C%20cinematic%20composition%2C%20moody%20lighting&width=1600&height=700&seq=drama-cover-005&orientation=landscape',
    featured: true,
    latest: false,
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `glory-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '55分钟',
    })),
  },
  {
    id: 'queen-of-tears',
    title: '泪之女王',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 7.9,
    description: '皇后集团财阀三代洪海仁与超市王子白贤宇这对结婚三年的夫妻，在面临婚姻危机时重新找回爱情的故事。',
    longDescription: '洪海仁是皇后集团的财阀三代，精明干练；白贤宇则是从农村走出来的"超市王子"，性格温暖。两人结婚三年后，婚姻陷入了危机。就在他们准备离婚之际，洪海仁被诊断出患有绝症，只剩三个月时间。这场突如其来的变故，让两人重新审视彼此的感情，开启了一段笑中带泪的治愈之旅。金秀贤和金智媛的绝佳化学反应让这部剧成为2024年最热门的韩剧之一。',
    director: '张英宇',
    actors: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 16,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20poster%2C%20couple%20in%20elegant%20clothing%20standing%20back%20to%20back%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%2C%20pastel%20pink%20and%20cream%20tones%2C%20professional%20photography&width=600&height=800&seq=drama-poster-006&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Seoul%20penthouse%20with%20city%20view%20at%20sunset%2C%20elegant%20interior%2C%20warm%20golden%20light%2C%20romantic%20ambiance%2C%20modern%20Korean%20drama%20set%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=drama-cover-006&orientation=landscape',
    featured: false,
    latest: true,
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `queentears-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '70分钟',
    })),
  },
  {
    id: 'breaking-bad',
    title: '绝命毒师',
    category: '美剧',
    categorySlug: 'american',
    year: 2008,
    rating: 9.6,
    description: '一位普通的高中化学老师在得知自己身患绝症后，为了给家人留下财产，利用自己的化学知识制造毒品，从平凡走向罪恶深渊。',
    longDescription: '沃尔特·怀特是一名普通的高中化学老师，生活平淡无奇。当被诊断出患有晚期肺癌后，他决定在自己死后为家人留下一笔财富。凭借出色的化学知识，他与曾经的学生杰西·平克曼联手，开始了制毒生涯。从最初的小打小闹到建立起庞大的毒品帝国，沃尔特在金钱与权力的诱惑下逐渐迷失自我。这部剧被誉为史上最伟大的电视剧之一，布莱恩·科兰斯顿的表演堪称教科书级别。',
    director: '文斯·吉里根',
    actors: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    region: '美国',
    language: '英语',
    totalEpisodes: 62,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=American%20crime%20drama%20poster%2C%20man%20in%20yellow%20hazmat%20suit%20standing%20in%20desert%2C%20dramatic%20lighting%2C%20minimalist%20composition%2C%20warm%20desert%20tones%2C%20iconic%20TV%20show%20poster%20style&width=600&height=800&seq=drama-poster-007&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=New%20Mexico%20desert%20landscape%20with%20RV%20vehicle%20in%20distance%2C%20golden%20hour%20sunlight%2C%20vast%20open%20space%2C%20cinematic%20wide%20shot%2C%20dramatic%20clouds%2C%20warm%20earthy%20tones&width=1600&height=700&seq=drama-cover-007&orientation=landscape',
    featured: false,
    latest: false,
    episodes: Array.from({ length: 62 }, (_, i) => ({
      id: `bb-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: i === 61 ? '55分钟' : '47分钟',
    })),
  },
  {
    id: 'stranger-things',
    title: '怪奇物语',
    category: '美剧',
    categorySlug: 'american',
    year: 2016,
    rating: 9.0,
    description: '在1980年代的印第安纳州小镇，一名小男孩神秘失踪后，他的朋友、家人和当地警方卷入了一个涉及秘密实验和超自然力量的谜团中。',
    longDescription: '1983年，印第安纳州霍金斯小镇。小男孩威尔·拜尔斯神秘失踪，他的母亲乔伊斯、警长霍珀以及一群小伙伴开始寻找他的下落。在寻找过程中，他们遇到了一个拥有超能力的女孩——十一，并逐渐揭开了一个隐藏在霍金斯国家实验室地下的惊天秘密。一个被称为"逆世界"的平行维度正在威胁着整个小镇的安全。这部剧完美融合了科幻、恐怖与青春成长元素，致敬了80年代的流行文化。',
    director: '达菲兄弟',
    actors: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    region: '美国',
    language: '英语',
    totalEpisodes: 34,
    updateStatus: '更新中',
    posterImage: 'https://readdy.ai/api/search-image?query=Retro%2080s%20sci-fi%20drama%20poster%2C%20group%20of%20kids%20on%20bicycles%20under%20red%20sky%2C%20nostalgic%20vibe%2C%20neon%20red%20title%2C%20synthwave%20aesthetic%2C%20dark%20mysterious%20atmosphere&width=600&height=800&seq=drama-poster-008&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Small%20American%20town%20at%20night%20with%20flickering%20streetlights%20and%20mist%2C%201980s%20setting%2C%20mysterious%20red%20glow%20in%20sky%2C%20cinematic%20horror%20atmosphere%2C%20nostalgic%20suburban%20scene&width=1600&height=700&seq=drama-cover-008&orientation=landscape',
    featured: false,
    latest: false,
    episodes: Array.from({ length: 34 }, (_, i) => ({
      id: `st-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
  },
  {
    id: 'shogun',
    title: '幕府将军',
    category: '美剧',
    categorySlug: 'american',
    year: 2024,
    rating: 9.2,
    description: '故事发生在1600年的日本，英国水手约翰·布莱克索恩因海难流落日本，被卷入了一场决定日本未来的权力斗争之中。',
    longDescription: '1600年，正值日本战国时代末期。英国水手约翰·布莱克索恩因船难漂流至日本海岸，被当地武士俘虏。在机缘巧合之下，他来到了吉井虎永（以德川家康为原型）的领地。此时的日本正处于权力真空期，五位摄政大臣明争暗斗。布莱克索恩凭借自己的航海知识和西方军事技术，成为了虎永争夺天下的重要棋子。这是一部关于文化碰撞、权力博弈与人性挣扎的史诗巨制，获得了2024年艾美奖多项大奖。',
    director: '乔纳森·范·塔克肯',
    actors: ['真田广之', '柯斯莫·贾维斯', '泽井杏奈', '浅野忠信'],
    region: '美国',
    language: '英语/日语',
    totalEpisodes: 10,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20samurai%20historical%20drama%20poster%2C%20samurai%20warrior%20in%20full%20armor%20holding%20katana%2C%20dramatic%20red%20and%20black%20background%2C%20ink%20wash%20painting%20style%2C%20traditional%20Japanese%20art%20aesthetic&width=600&height=800&seq=drama-poster-009&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Japanese%20castle%20and%20village%20at%20dawn%20with%20mist%2C%20mount%20Fuji%20in%20distance%2C%20cherry%20blossoms%2C%20traditional%20architecture%2C%20cinematic%20landscape%2C%20serene%20atmosphere&width=1600&height=700&seq=drama-cover-009&orientation=landscape',
    featured: true,
    latest: true,
    episodes: Array.from({ length: 10 }, (_, i) => ({
      id: `shogun-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '60分钟',
    })),
  },
  {
    id: 'silent',
    title: '静雪',
    category: '日剧',
    categorySlug: 'japanese',
    year: 2022,
    rating: 8.5,
    description: '高中时曾是恋人的青羽䌷和佐仓想，因男孩患上听觉障碍而分手。八年后重逢，两人用新的方式重新走近彼此的心。',
    longDescription: '高中时代，青羽䌷被佐仓想在晨会上朗读作文的声音所吸引，两人开始交往。然而高三那年，佐仓想被诊断出患有进行性听力障碍，他没有告诉任何人，选择了默默离开。八年后，䌷在东京的一家超市偶遇了已经完全失去听力的想。曾经的恋人变成了无法用声音交流的陌生人。当过去的情感被唤醒，两人开始尝试用手语、文字和眼神，重新走近彼此的内心。这是一部关于失去、接纳与重新开始的温柔故事。',
    director: '风间太树',
    actors: ['川口春奈', '目黑莲', '铃鹿央士', '樱井由纪'],
    region: '日本',
    language: '日语',
    totalEpisodes: 11,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20drama%20poster%2C%20young%20couple%20facing%20each%20other%20in%20snow%2C%20soft%20winter%20light%2C%20minimalist%20Japanese%20aesthetic%2C%20gentle%20atmosphere%2C%20cream%20and%20soft%20gray%20tones&width=600&height=800&seq=drama-poster-010&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20street%20in%20gentle%20snowfall%20at%20dusk%2C%20warm%20streetlights%2C%20quiet%20winter%20atmosphere%2C%20Japanese%20urban%20landscape%2C%20romantic%20mood%2C%20soft%20focus&width=1600&height=700&seq=drama-cover-010&orientation=landscape',
    featured: false,
    latest: true,
    episodes: Array.from({ length: 11 }, (_, i) => ({
      id: `silent-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '46分钟',
    })),
  },
  {
    id: 'restart-life',
    title: '重启人生',
    category: '日剧',
    categorySlug: 'japanese',
    year: 2023,
    rating: 9.1,
    description: '33岁的近藤麻美意外死亡后来到死后世界，被告知下辈子会变成食蚁兽。为了来世投胎成人，她决定带着记忆重启人生。',
    longDescription: '33岁的近藤麻美是一名普通的公务员，生活平淡如水。某天她意外遭遇车祸去世，来到了一间纯白色的死后接待室。工作人员告诉她：下辈子她会投胎成为一只危地马拉的大食蚁兽。不想变成食蚁兽的麻美，选择带着记忆重新活一次同样的人生。她决定多积阴德，让自己来世能再次投胎成为人类。于是，一场充满温情与笑料的"积德"之旅开始了。这部剧以独特的视角探讨了友情、亲情和人生的意义。',
    director: '水野格',
    actors: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    region: '日本',
    language: '日语',
    totalEpisodes: 10,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20comedy%20drama%20poster%2C%20woman%20surrounded%20by%20floating%20clocks%20in%20white%20space%2C%20whimsical%20atmosphere%2C%20minimalist%20Japanese%20design%2C%20soft%20cream%20and%20warm%20beige%20tones&width=600&height=800&seq=drama-poster-011&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20small%20town%20street%20with%20local%20shops%20and%20warm%20sunlight%2C%20nostalgic%20atmosphere%2C%20everyday%20life%20scene%2C%20Japanese%20slice%20of%20life%2C%20cinematic%20composition&width=1600&height=700&seq=drama-cover-011&orientation=landscape',
    featured: false,
    latest: true,
    episodes: Array.from({ length: 10 }, (_, i) => ({
      id: `restartlife-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
  },
  {
    id: 'blossoms-shanghai',
    title: '繁花',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 8.4,
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，在商界崭露头角，书写了一段沪上弄潮儿女的传奇故事。',
    longDescription: '九十年代的上海，处处是机遇，处处是挑战。阿宝是一个从底层打拼起来的年轻人，凭借改革开放的春风，他在股票、外贸等各个领域摸爬滚打，逐渐在商界崭露头角。在这个充满诱惑与陷阱的时代，他与玲子、汪小姐、李李等各色人物交织出了一幅时代洪流下的人物群像。王家卫导演耗时三年打造的这部电视剧，用独特的镜头语言和光影美学，重现了那个让人怀念的上海黄金年代。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    language: '汉语普通话/上海话',
    totalEpisodes: 30,
    updateStatus: '已完结',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%2C%20neon%20lights%20background%2C%20nostalgic%20golden%20tones%2C%20film%20noir%20aesthetic%2C%20Wong%20Kar%20Wai%20style%2C%20cinematic%20portrait&width=600&height=800&seq=drama-poster-012&orientation=portrait',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Bund%20at%20night%20with%20neon%20lights%20and%20busy%20streets%2C%20nostalgic%20atmosphere%2C%20golden%20and%20red%20tones%2C%20cinematic%20wide%20shot%2C%20retro%20vintage%20style&width=1600&height=700&seq=drama-cover-012&orientation=landscape',
    featured: false,
    latest: true,
    episodes: Array.from({ length: 30 }, (_, i) => ({
      id: `blossoms-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
  },
];

export const featuredDramas = dramas.filter((d) => d.featured);
export const latestDramas = dramas.filter((d) => d.latest);
export const getDramasByCategory = (slug: string) => {
  if (slug === 'all') return dramas;
  return dramas.filter((d) => d.categorySlug === slug);
};
export const getDramaById = (id: string) => dramas.find((d) => d.id === id);
export const getRelatedDramas = (id: string, limit: number = 4) => {
  const drama = getDramaById(id);
  if (!drama) return [];
  return dramas
    .filter((d) => d.id !== id && d.categorySlug === drama.categorySlug)
    .slice(0, limit);
};

export const testimonials = [
  {
    id: 't1',
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20corporate%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-001&orientation=squarish',
    rating: 5,
    comment: '天天影院的资源真的太全了！我想看的国产剧和韩剧这里都有，而且更新速度超快，画质也很清晰，强烈推荐！',
    date: '2024-07-15',
  },
  {
    id: 't2',
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20warm%20smile%2C%20clean%20white%20background%2C%20corporate%20style%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-002&orientation=squarish',
    rating: 5,
    comment: '分类做得很细致，找剧非常方便。最近在追美剧，每部都有详细的分集列表，追剧体验满分！',
    date: '2024-06-28',
  },
  {
    id: 't3',
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%2C%20confident%20expression%2C%20clean%20white%20background%2C%20corporate%20style%2C%20warm%20lighting&width=100&height=100&seq=avatar-003&orientation=squarish',
    rating: 5,
    comment: '我这个年纪的人看剧比较挑，天天影院的好剧推荐做得很用心，每次都能发现一些冷门但质量很高的剧集。',
    date: '2024-06-10',
  },
  {
    id: 't4',
    name: '小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20bright%20smile%2C%20clean%20white%20background%2C%20casual%20corporate%20style%2C%20natural%20daylight&width=100&height=100&seq=avatar-004&orientation=squarish',
    rating: 4,
    comment: '日剧资源挺丰富的，就是希望能再多一些日剧的分类。整体使用体验很不错，界面简洁好看。',
    date: '2024-05-22',
  },
];

export const faqData = [
  {
    question: '天天影院需要注册会员才能观看吗？',
    answer: '不需要。天天影院目前所有内容均免费提供，您无需注册即可浏览和观看所有剧集信息。',
  },
  {
    question: '剧集更新的频率是怎样的？',
    answer: '我们会在各大平台更新后第一时间同步最新剧集信息。热门剧集通常在播出后24小时内完成更新，确保您不错过任何精彩内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '天天影院采用响应式设计，完美支持电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅的浏览体验。',
  },
  {
    question: '如何快速找到我想看的剧集？',
    answer: '您可以通过首页顶部的分类导航快速筛选您感兴趣的类型，也可以使用搜索功能直接查找您想要观看的剧集。',
  },
  {
    question: '剧集画质如何？有高清版本吗？',
    answer: '天天影院提供的剧集资源均支持高清画质。我们致力于为用户提供最佳的观影体验，多部热门剧集还支持超高清版本。',
  },
];